<template>

<div class="tag" v-on:click="$emit('click')">

    <div class="tag-colour" :style="{backgroundColor: tag.colour, color: tag.fore}" />

    <div class="tag-name">

        <span class="tag-family" v-if="hasFamily && selected">{{ familyName }} /</span>

        {{ tag.text }} 
    
        <i class="fa fa-remove" v-if="selected" />

    </div>
    
</div>

</template>

<script>

export default {

	props: ['tag', 'selected'],

    computed: {

         family: function() {

            return (this.hasFamily) ? this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

                return family.id === this.tag.family

            }.bind(this)) : false

        },

        familyName: function() {

            return this.family.name

        },

        hasFamily: function() {

            return this.tag.family

        }

    }

}

</script>

<style scoped>

.tag {
	font-size: 14px;
    color: #fff;
	height: 24px;
	line-height: 24px;
    border-radius: 4px;
	user-select: none;
    padding: 0px 10px;
    cursor: pointer;
    font-weight: 400;
    display: grid;
    grid-template-columns: 16px auto;
	cursor: pointer;
    align-items: center;
    flex-direction: row;
    grid-gap: 10px;
}

.is-mobile .tag {
    line-height: 32px;
    height: 32px;
}

.tag-colour {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1px solid #fff;
}

.tag-family {
    opacity: 0.5;
}

.tag .fa {
	position: absolute;
	right: 3px;
	top: 0px;
	line-height: 24px;
	color: #fff;
}

.tag:hover {
	background-color: rgba(0, 0, 0, 0.15);
}

</style>
